import {
  DEFAULT_VITAL_TARGET_VERSION,
  isVitalTargetVersion,
  type VitalTargetVersion,
} from "@defibrillator/vital-adapter";
import {
  EMPTY_GENERATION_OPTIONS,
  type PresetGenerationOptions,
} from "../../shared/generation-options.js";

const PANEL_OPEN_STORAGE_KEY = "defibrillator.generationOptionsOpen";
const VITAL_VERSION_STORAGE_KEY = "defibrillator.vitalTargetVersion";

export function readGenerationOptionsPanelOpen(): boolean {
  try {
    const raw = localStorage.getItem(PANEL_OPEN_STORAGE_KEY);
    if (raw === null) return true;
    return raw === "true";
  } catch {
    return true;
  }
}

export function writeGenerationOptionsPanelOpen(open: boolean): void {
  try {
    localStorage.setItem(PANEL_OPEN_STORAGE_KEY, open ? "true" : "false");
  } catch {
    // Ignore quota errors and private browsing modes.
  }
}

export function readStoredVitalTargetVersion(): VitalTargetVersion | undefined {
  try {
    const raw = localStorage.getItem(VITAL_VERSION_STORAGE_KEY);
    if (raw === null) return undefined;
    return isVitalTargetVersion(raw) ? raw : undefined;
  } catch {
    return undefined;
  }
}

export function writeStoredVitalTargetVersion(version: VitalTargetVersion): void {
  try {
    localStorage.setItem(VITAL_VERSION_STORAGE_KEY, version);
  } catch {
    // Ignore quota errors and private browsing modes.
  }
}

export function readInitialGenerationOptions(): PresetGenerationOptions {
  const vitalVersion = readStoredVitalTargetVersion();
  if (!vitalVersion) return EMPTY_GENERATION_OPTIONS;
  return { ...EMPTY_GENERATION_OPTIONS, vitalVersion };
}

export function persistGenerationOptionsChange(options: PresetGenerationOptions): void {
  writeStoredVitalTargetVersion(options.vitalVersion ?? DEFAULT_VITAL_TARGET_VERSION);
}
